import React, { type HTMLAttributes } from 'react';
import Truncate from 'react-truncate';
import classNames from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import type { NodeEvent } from '../../../../types/uncinc_profile/nodes';
import { dateFormatter } from '../../../../helpers';

import './style.scss';

interface NodeEventTeaserProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<NodeEvent>;
  classes: string;
}

const NodeEventTeaser: React.FC<NodeEventTeaserProps> = ({ entity, classes }) => {
  const node = entity.toJS();
  const title = node.title[0].value;
  const lang = node.langcode[0]?.value;
  const path = node.paths[lang];
  const locations = node.field_locations;

  return (
    <div className={classNames('NodeEvent', 'NodeEventTeaser', classes)}>
      <div className="NodeEventTeaser__info">
        <div className="NodeEventTeaser__date">
          {dateFormatter(node.field_date[0].value, lang)}
        </div>
        {locations && locations.length > 0 && (
          <div className="NodeEventPage__locations">
            {locations.map((location) => <span>{location.entity.name[0].value}</span>)}
          </div>
        )}
      </div>
      <div className="NodeEventTeaser__content">
        <h3 className="NodeEventTeaser__heading">
          <CoreLink href={path}>
            {title}
          </CoreLink>
        </h3>
        <Truncate lines={3}>
          <WysiwygField
            html={node.body[0]?.summary}
            className="NodeEventTeaser__body"
          />
        </Truncate>
      </div>
    </div>
  );
};

export default NodeEventTeaser;
